import { Icon } from '~/ComponentsTW/wm/icon';
import * as React from 'react';

const StandaloneLink = ({ onAction, loading = false, icon, text, href, download }) => {
    const handleClick = e => {
        if (onAction && !loading) {
            e.preventDefault();
            onAction();
        } else if (loading) {
            e.preventDefault();
        }
    };

    return (
        <a
            aria-disabled={loading}
            className={
                `
                tw-text-primary hover:tw-underline tw-cursor-pointer tw-font-bold tw-text-md !tw-mt-4 tw-inline-flex tw-items-center
                ${loading ? 'tw-text-gray-500 tw-cursor-not-allowed hover:tw-text-gray-500' : ''}
                `
            }
            download={download}
            href={href}
            onClick={handleClick}
            rel="noreferrer" target="_blank"
        >
            {icon && <Icon icon={icon}/>}
            {text}
        </a>
    );
};

StandaloneLink.displayName = 'StandaloneLink';

export { StandaloneLink };
